// define selectors that work on local state slice

import type { Api } from './apiRepository';
import type { ClientRequestState } from './clientRequest.types';
import type { RootState } from '../../../configuration/setup/store';
import { createSelector } from '@reduxjs/toolkit';

const getClientAccountIdLocal = (state: ClientRequestState) => state.associatedAccountId;
const getIsMobileAppClientLocal = (state: ClientRequestState) => state.isMobileAppClient;

const requiresPermissionsLocal = (state: ClientRequestState) => state.requiresPermissions;

const getCurrentStepLocal = (state: ClientRequestState) => state.currentStep;

export const getApiLocal = (state: ClientRequestState) => (api: Api) =>
    state.apiSelectionState[api] ? state.apiSelectionState[api] : { selected: false, read: false, write: false };

export const getApiSelectionStateLocal = (state: ClientRequestState) => state.apiSelectionState;

export const getCustomScopesLocal = (state: ClientRequestState) => state.customScopes;
export const getShowCustomScopesLocal = (state: ClientRequestState) => state.showCustomScopes;

// define global selectors

const getClientRequest = (state: RootState) => state.clientRequest;

export const getClientType = (state: RootState) => state.clientRequest.clientType;
export const getClientName = (state: RootState) => state.clientRequest.clientName;
export const getClientEmail = (state: RootState) => state.clientRequest.clientEmail;
export const getClientDescription = (state: RootState) => state.clientRequest.clientDescription;
export const getClientDetailedDescription = (state: RootState) => state.clientRequest.clientDetailedDescription;

export const getClientAccountId = (state: RootState) => getClientAccountIdLocal(getClientRequest(state));
export const getIsMobileAppClient = (state: RootState) => getIsMobileAppClientLocal(getClientRequest(state));

export const getRequiresPermissions = (state: RootState) => requiresPermissionsLocal(getClientRequest(state));

export const getCurrentStep = (state: RootState) => getCurrentStepLocal(getClientRequest(state));

export const getApi = (state: RootState) => getApiLocal(getClientRequest(state));

export const getApiSelectionState = (state: RootState) => getApiSelectionStateLocal(getClientRequest(state));

export const getCustomScopes = (state: RootState) => getCustomScopesLocal(getClientRequest(state));
export const getShowCustomScopes = (state: RootState) => getShowCustomScopesLocal(getClientRequest(state));

export const getCustomScopesAsArray = createSelector([getCustomScopes], scopes =>
    scopes
        .replace(/\s+/g, '')
        .split(',')
        .filter(it => it)
);

export const getClientDetails = createSelector(
    [
        getClientType,
        getClientName,
        getClientEmail,
        getClientDescription,
        getClientDetailedDescription,
        getClientAccountId,
    ],
    (type, name, email, description, detailedDescription, accountId) => ({
        type,
        name,
        email,
        description,
        detailedDescription,
        accountId,
    })
);
